import FooterApp from './FooterApp';

export default FooterApp;
